// Models
import { SiteFeatures, SiteFeaturesJson } from './siteFeatures'
import { SiteSettings, SiteSettingsJson } from './siteSettings'
import { SiteTerms, SiteTermsDto, termsFromDto } from './siteTerms'

export interface SiteConfigJson {
    id: number
    features: SiteFeaturesJson
    settings: SiteSettingsJson
    terms: SiteTermsDto
}

export class SiteConfig {
    id: number
    features: SiteFeatures
    settings: SiteSettings
    terms: SiteTerms

    constructor (id: number, features: SiteFeatures, settings: SiteSettings, terms: SiteTerms) {
        this.id = id
        this.features = features
        this.settings = settings
        this.terms = terms
    }

    static fromJson(json: SiteConfigJson): SiteConfig {
        return new SiteConfig(
            json.id,
            SiteFeatures.fromJson(json.features),
            SiteSettings.fromJson(json.settings),
            termsFromDto(json.terms),
        )
    }
}
